module.exports = __webpack_public_path__ + "images/FUSA_icons/086-trolley.dcc5182c7b353a73b86e4ab62fb3b20a.svg";